"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = exports.Form = void 0;
var React = __importStar(require("react"));
var lib_1 = require("@ribit/lib");
var validators_1 = require("./validators");
var defaultProps = {
    realtime: false,
    initial: {},
    onSubmit: function (values) {
        (0, lib_1.table)(values);
    },
};
var getInitialState = function (form) {
    var initial = Object.assign({}, form.props.initial);
    return {
        initial: initial,
        values: initial,
        errors: {},
        form: form,
    };
};
var FormContext = React.createContext(null);
exports.FormContext = FormContext;
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = getInitialState(_this);
        _this.fields = [];
        _this.componentDidUpdate = function (prevProps) {
            if (!(0, lib_1.isEqual)(prevProps.initial, _this.props.initial)) {
                _this.setState({ values: _this.props.initial, errors: {} });
            }
        };
        _this.valueChanged = function (name, value, multiple, isInitial) {
            var values = Object.assign({}, _this.state.values);
            if (multiple) {
                if (!Array.isArray(values[name])) {
                    value = [value];
                }
                else {
                    var tempValues = (values[name] || []).slice();
                    var foundIndex = tempValues.findIndex(function (val) {
                        return (0, lib_1.isEqual)(val, value);
                    });
                    if (foundIndex > -1) {
                        tempValues.splice(foundIndex, 1);
                    }
                    else {
                        tempValues.push(value);
                    }
                    value = tempValues;
                }
            }
            values[name] = value;
            var newState = { values: values };
            if (isInitial) {
                var initial = Object.assign({}, _this.state.initial);
                initial[name] = value;
                newState.initial = initial;
            }
            _this.setState(newState);
            if (_this.props.realtime) {
                _this.submit(values);
            }
        };
        _this.reset = function (newState) {
            var values = Object.assign({}, newState || _this.state.initial);
            _this.setState({ values: values, errors: {} });
        };
        _this.validate = function (values) {
            var _a = _this.props, validate = _a.validate, validateSchema = _a.validateSchema, onError = _a.onError;
            if (validateSchema) {
                return validateSchema
                    .validate(values, {
                    abortEarly: false,
                })
                    .catch(function (errors) {
                    var availableErrors = (errors.inner || []).reduce(function (previous, error) {
                        var path = error.path.replace(/\[\d+\]/g, "");
                        previous[path] = error.errors;
                        return previous;
                    }, {});
                    if (onError) {
                        onError(availableErrors);
                    }
                    throw availableErrors;
                });
            }
            return new Promise(function (resolve, reject) {
                var errors = {};
                _this.fields.map(function (field) {
                    if (field.props.required && !(0, validators_1.required)(values[field.name])) {
                        errors[field.name] = ["This field is required"];
                    }
                });
                if (validate) {
                    var validationErrors = validate(values);
                    errors = Object.assign(errors, validationErrors);
                }
                if (Object.keys(errors).length === 0) {
                    resolve(values);
                }
                else {
                    if (onError) {
                        onError(errors);
                    }
                    reject(errors);
                }
            });
        };
        _this.onSubmit = function (event) {
            if (event === void 0) { event = null; }
            event.preventDefault();
            if (_this.props.onFilterValues) {
                var values = _this.props.onFilterValues(_this.state.values);
                _this.setState({
                    values: values,
                });
                _this.submit(values);
            }
            else {
                _this.submit(_this.state.values);
            }
            return false;
        };
        _this.submit = function (values) {
            var onSubmit = _this.props.onSubmit;
            _this.validate(values)
                .then(function (values) {
                _this.setState({ errors: {} });
                var submitted = onSubmit(values, _this._internals());
                if (!submitted) {
                    return false;
                }
                submitted.catch(function (response) {
                    if (response.status !== 200) {
                        var errors = {};
                        if (response.data) {
                            errors = response.data.errors;
                        }
                        _this.setState({ errors: errors });
                    }
                });
            })
                .catch(function (errors) {
                _this.setState({ errors: errors });
            });
            return false;
        };
        _this.registerField = function (field) {
            _this.fields.push(field);
        };
        _this._internals = function () {
            return {
                values: _this.state.values,
                reset: _this.reset,
                errors: _this.state.errors,
                submit: _this.submit,
                valueChanged: _this.valueChanged,
                isDirty: !(0, lib_1.isEqual)(_this.state.values, _this.state.initial),
            };
        };
        return _this;
    }
    Form.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.load) {
            this.props.load().then(function (values) {
                _this.setState(function () { return ({
                    initial: values,
                    values: values,
                    errors: {},
                }); });
            });
        }
    };
    Form.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        var props = this._internals();
        var Provider = FormContext.Provider;
        return (React.createElement(Provider, { value: this.state },
            React.createElement("form", { onSubmit: this.onSubmit, method: "post", className: className }, children
                ? (0, lib_1.isFunction)(children)
                    ? children(props)
                    : children
                : null)));
    };
    Form.defaultProps = defaultProps;
    return Form;
}(React.Component));
exports.Form = Form;
exports.default = Form;
//# sourceMappingURL=form.js.map